import React, { Component } from 'react';
import { 
  Table, 
  Input, 
  Button, 
  Card, 
  Row, 
  Col, 
  Tabs, 
  Modal, 
  Form, 
  Select, 
  DatePicker, 
  message, 
  Spin, 
  Tag, 
  Descriptions, 
  Timeline, 
  Statistic, 
  Space,
  Tooltip,
  Popconfirm,
  Drawer,
  Collapse,
  Badge,
  Avatar,
  List,
  Divider
} from 'antd';
import { 
  SearchOutlined, 
  EditOutlined, 
  DeleteOutlined, 
  EyeOutlined, 
  UserOutlined, 
  PhoneOutlined, 
  MailOutlined, 
  HomeOutlined,
  CalendarOutlined,
  MedicineBoxOutlined,
  HistoryOutlined,
  PrinterOutlined,
  DownloadOutlined,
  ReloadOutlined
} from '@ant-design/icons';
import axios from 'axios';
import moment from 'moment';
import * as serverconfig from '../../serverconn';
import ReactToPrint from 'react-to-print';
import ReactExport from "@ibrahimrahmani/react-export-excel";

const { TabPane } = Tabs;
const { Option } = Select;
const { Panel } = Collapse;
const { TextArea } = Input;
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

// Print Component for Patient Reports
class PatientReportToPrint extends Component {
  render() {
    const { patients, reportTitle, dateRange } = this.props;
    
    return (
      <div style={{padding:'30px', fontFamily:'Arial, sans-serif', backgroundColor:'white'}}>
        {/* Header */}
        <div style={{borderBottom:'3px solid #1890ff', paddingBottom:'20px', marginBottom:'30px', textAlign:'center'}}>
          <h1 style={{color:'#1890ff', margin:'0', fontSize:'24px'}}>
            UMOJA PATIENT MANAGEMENT SYSTEM
          </h1>
          <h2 style={{color:'#333', margin:'10px 0', fontSize:'18px'}}>
            {reportTitle || 'Patient Report'}
          </h2>
          {dateRange && (
            <p style={{color:'#666', fontSize:'14px'}}>
              Report Period: {dateRange}
            </p>
          )}
          <p style={{color:'#999', fontSize:'12px'}}>
            Generated on: {new Date().toLocaleDateString('en-GB')} at {new Date().toLocaleTimeString('en-GB')}
          </p>
        </div>

        {/* Summary Statistics */}
        <div style={{marginBottom:'30px', padding:'20px', backgroundColor:'#f8f9fa', borderRadius:'8px'}}>
          <Row gutter={16}>
            <Col span={6}>
              <div style={{textAlign:'center'}}>
                <h3 style={{color:'#1890ff', fontSize:'24px', margin:'0'}}>{patients.length}</h3>
                <p style={{color:'#666', margin:'0'}}>Total Patients</p>
              </div>
            </Col>
            <Col span={6}>
              <div style={{textAlign:'center'}}>
                <h3 style={{color:'#52c41a', fontSize:'24px', margin:'0'}}>
                  {patients.filter(p => p.sex === 'Male').length}
                </h3>
                <p style={{color:'#666', margin:'0'}}>Male Patients</p>
              </div>
            </Col>
            <Col span={6}>
              <div style={{textAlign:'center'}}>
                <h3 style={{color:'#fa8c16', fontSize:'24px', margin:'0'}}>
                  {patients.filter(p => p.sex === 'Female').length}
                </h3>
                <p style={{color:'#666', margin:'0'}}>Female Patients</p>
              </div>
            </Col>
            <Col span={6}>
              <div style={{textAlign:'center'}}>
                <h3 style={{color:'#722ed1', fontSize:'24px', margin:'0'}}>
                  {patients.filter(p => p.age_in_years < 18).length}
                </h3>
                <p style={{color:'#666', margin:'0'}}>Pediatric (&lt;18)</p>
              </div>
            </Col>
          </Row>
        </div>

        {/* Patient Table */}
        <table style={{width:'100%', borderCollapse:'collapse', fontSize:'11px'}}>
          <thead style={{backgroundColor:'#f8f9fa'}}>
            <tr>
              <th style={{padding:'8px', border:'1px solid #dee2e6', fontWeight:'bold'}}>#</th>
              <th style={{padding:'8px', border:'1px solid #dee2e6', fontWeight:'bold'}}>Patient Name</th>
              <th style={{padding:'8px', border:'1px solid #dee2e6', fontWeight:'bold'}}>Age</th>
              <th style={{padding:'8px', border:'1px solid #dee2e6', fontWeight:'bold'}}>Sex</th>
              <th style={{padding:'8px', border:'1px solid #dee2e6', fontWeight:'bold'}}>Phone</th>
              <th style={{padding:'8px', border:'1px solid #dee2e6', fontWeight:'bold'}}>Nationality</th>
              <th style={{padding:'8px', border:'1px solid #dee2e6', fontWeight:'bold'}}>Registration Date</th>
              <th style={{padding:'8px', border:'1px solid #dee2e6', fontWeight:'bold'}}>Sample Number</th>
            </tr>
          </thead>
          <tbody>
            {patients.map((patient, index) => (
              <tr key={patient.id} style={{backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa'}}>
                <td style={{padding:'6px', border:'1px solid #dee2e6', textAlign:'center'}}>{index + 1}</td>
                <td style={{padding:'6px', border:'1px solid #dee2e6', fontWeight:'500'}}>{patient.names}</td>
                <td style={{padding:'6px', border:'1px solid #dee2e6', textAlign:'center'}}>{patient.age_in_years || patient.age || 'N/A'}</td>
                <td style={{padding:'6px', border:'1px solid #dee2e6', textAlign:'center'}}>{patient.sex}</td>
                <td style={{padding:'6px', border:'1px solid #dee2e6'}}>{patient.phone_number || 'N/A'}</td>
                <td style={{padding:'6px', border:'1px solid #dee2e6'}}>{patient.nationality || 'N/A'}</td>
                <td style={{padding:'6px', border:'1px solid #dee2e6', textAlign:'center'}}>
                  {patient.created_at ? moment(patient.created_at).format('DD/MM/YYYY') : 'N/A'}
                </td>
                <td style={{padding:'6px', border:'1px solid #dee2e6'}}>{patient.pending_sample_pickup_number || 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Footer */}
        <div style={{marginTop:'30px', borderTop:'2px solid #f0f0f0', paddingTop:'15px', textAlign:'center'}}>
          <p style={{color:'#999', fontSize:'11px'}}>
            This is a computer-generated report from Umoja Patient Management System
          </p>
          <p style={{color:'#999', fontSize:'11px'}}>
            © {new Date().getFullYear()} Umoja Integrated Medical Couriers
          </p>
        </div>
      </div>
    );
  }
}

class PatientManagementView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Data states
      patients: [],
      allPatients: [],
      deliveryHistory: [],
      pendingPickups: [],
      loading: false,
      
      // Modal states
      editModalVisible: false,
      viewModalVisible: false,
      historyDrawerVisible: false,
      selectedPatient: null,
      
      // Search and filter states
      searchText: '',
      selectedSex: '',
      selectedNationality: '',
      ageRange: [],
      
      // Form states
      editForm: {},
      
      // Statistics
      statistics: {
        totalPatients: 0,
        malePatients: 0,
        femalePatients: 0,
        pediatricPatients: 0,
        recentRegistrations: 0
      },
      
      // Nationalities for dropdown
      nationalities: [
        'Ugandan', 'Kenyan', 'Tanzanian', 'Rwandan', 'Burundian', 'Congolese',
        'Ethiopian', 'Sudanese', 'South Sudanese', 'Somali', 'American', 'British',
        'Canadian', 'German', 'French', 'Italian', 'Spanish', 'Portuguese', 'Dutch',
        'Belgian', 'Swedish', 'Norwegian', 'Danish', 'Finnish', 'Indian', 'Chinese',
        'Japanese', 'Korean', 'Pakistani', 'Bangladeshi', 'Sri Lankan', 'Other'
      ]
    };
  }

  componentDidMount() {
    this.loadPatients();
  }

  // Load patients data
  loadPatients = async () => {
    this.setState({ loading: true });
    
    try {
      const token = localStorage.getItem('token');
      axios.defaults.headers = {
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`
      };

      const [patientsRes, pickupsRes] = await Promise.all([
        axios.get(`${serverconfig.backendserverurl}/api/patients/`),
        axios.get(`${serverconfig.backendserverurl}/api/pending_umoja_pickups/`)
      ]);

      const patients = patientsRes.data.results || patientsRes.data;
      const pickups = pickupsRes.data.results || pickupsRes.data;

      // Calculate statistics
      const statistics = {
        totalPatients: patients.length,
        malePatients: patients.filter(p => p.sex === 'Male').length,
        femalePatients: patients.filter(p => p.sex === 'Female').length,
        pediatricPatients: patients.filter(p => p.age_in_years < 18).length,
        recentRegistrations: patients.filter(p => 
          moment(p.created_at).isAfter(moment().subtract(30, 'days'))
        ).length
      };

      this.setState({
        patients,
        allPatients: patients,
        pendingPickups: pickups,
        statistics,
        loading: false
      });

    } catch (error) {
      console.error('Error loading patients:', error);
      message.error('Failed to load patient data');
      this.setState({ loading: false });
    }
  };

  // Search and filter functions
  handleSearch = (value) => {
    this.setState({ searchText: value });
    this.applyFilters({ searchText: value });
  };

  handleSexFilter = (value) => {
    this.setState({ selectedSex: value });
    this.applyFilters({ selectedSex: value });
  };

  handleNationalityFilter = (value) => {
    this.setState({ selectedNationality: value });
    this.applyFilters({ selectedNationality: value });
  };

  applyFilters = (newFilters = {}) => {
    const { 
      searchText = this.state.searchText,
      selectedSex = this.state.selectedSex,
      selectedNationality = this.state.selectedNationality
    } = newFilters;

    let filtered = [...this.state.allPatients];

    // Apply search filter
    if (searchText) {
      filtered = filtered.filter(patient =>
        patient.names?.toLowerCase().includes(searchText.toLowerCase()) ||
        patient.phone_number?.includes(searchText) ||
        patient.national_id_number?.includes(searchText) ||
        patient.patient_opd_ipd_number?.includes(searchText)
      );
    }

    // Apply sex filter
    if (selectedSex) {
      filtered = filtered.filter(patient => patient.sex === selectedSex);
    }

    // Apply nationality filter
    if (selectedNationality) {
      filtered = filtered.filter(patient => patient.nationality === selectedNationality);
    }

    this.setState({ patients: filtered });
  };

  clearFilters = () => {
    this.setState({
      searchText: '',
      selectedSex: '',
      selectedNationality: '',
      patients: this.state.allPatients
    });
  };

  // Patient actions
  viewPatient = (patient) => {
    this.setState({
      selectedPatient: patient,
      viewModalVisible: true
    });
  };

  editPatient = (patient) => {
    this.setState({
      selectedPatient: patient,
      editForm: { ...patient },
      editModalVisible: true
    });
  };

  viewPatientHistory = async (patient) => {
    this.setState({ 
      selectedPatient: patient,
      historyDrawerVisible: true,
      loading: true 
    });

    try {
      // Load delivery history for this patient
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${serverconfig.backendserverurl}/api/delivery_items/?patient=${patient.id}`
      );
      
      this.setState({
        deliveryHistory: response.data.results || response.data,
        loading: false
      });
    } catch (error) {
      console.error('Error loading patient history:', error);
      message.error('Failed to load patient history');
      this.setState({ loading: false });
    }
  };

  savePatient = async () => {
    const { selectedPatient, editForm } = this.state;
    
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${serverconfig.backendserverurl}/api/patients/${selectedPatient.id}/`,
        editForm,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${token}`
          }
        }
      );

      message.success('Patient updated successfully');
      this.setState({ editModalVisible: false });
      this.loadPatients(); // Reload data
    } catch (error) {
      console.error('Error updating patient:', error);
      message.error('Failed to update patient');
    }
  };

  deletePatient = async (patientId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(
        `${serverconfig.backendserverurl}/api/patients/${patientId}/`,
        {
          headers: {
            Authorization: `Token ${token}`
          }
        }
      );

      message.success('Patient deleted successfully');
      this.loadPatients(); // Reload data
    } catch (error) {
      console.error('Error deleting patient:', error);
      message.error('Failed to delete patient');
    }
  };

  render() {
    const { 
      patients, 
      loading, 
      statistics,
      editModalVisible,
      viewModalVisible,
      historyDrawerVisible,
      selectedPatient,
      editForm,
      deliveryHistory,
      searchText,
      selectedSex,
      selectedNationality,
      nationalities
    } = this.state;

    const columns = [
      {
        title: '#',
        key: 'index',
        width: 50,
        render: (text, record, index) => index + 1
      },
      {
        title: 'Patient Name',
        dataIndex: 'names',
        key: 'names',
        render: (text, record) => (
          <div>
            <strong style={{ color: '#1890ff' }}>{text}</strong>
            {record.patient_opd_ipd_number && (
              <div style={{ fontSize: '12px', color: '#666' }}>
                OPD/IPD: {record.patient_opd_ipd_number}
              </div>
            )}
          </div>
        )
      },
      {
        title: 'Age/Sex',
        key: 'age_sex',
        width: 100,
        render: (text, record) => (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: '500' }}>
              {record.age_in_years || record.age || 'N/A'}
            </div>
            <Tag color={record.sex === 'Male' ? 'blue' : 'pink'}>
              {record.sex}
            </Tag>
          </div>
        )
      },
      {
        title: 'Contact Info',
        key: 'contact',
        render: (text, record) => (
          <div>
            {record.phone_number && (
              <div style={{ fontSize: '12px' }}>
                <PhoneOutlined style={{ color: '#52c41a' }} /> {record.phone_number}
              </div>
            )}
            {record.email_address && (
              <div style={{ fontSize: '12px', marginTop: '2px' }}>
                <MailOutlined style={{ color: '#1890ff' }} /> {record.email_address}
              </div>
            )}
          </div>
        )
      },
      {
        title: 'Location',
        key: 'location',
        render: (text, record) => (
          <div>
            {record.village_of_residence && (
              <div style={{ fontSize: '12px' }}>
                <HomeOutlined style={{ color: '#fa8c16' }} /> {record.village_of_residence}
              </div>
            )}
            <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
              {record.nationality || 'N/A'}
            </div>
          </div>
        )
      },
      {
        title: 'Sample Info',
        key: 'sample_info',
        render: (text, record) => (
          <div>
            {record.pending_sample_pickup_number && (
              <Tag color="green">
                <MedicineBoxOutlined /> {record.pending_sample_pickup_number}
              </Tag>
            )}
            <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
              Reg: {moment(record.created_at).format('DD/MM/YYYY')}
            </div>
          </div>
        )
      },
      {
        title: 'Actions',
        key: 'actions',
        width: 150,
        render: (text, record) => (
          <Space size="small">
            <Tooltip title="View Details">
              <Button
                type="primary"
                size="small"
                icon={<EyeOutlined />}
                onClick={() => this.viewPatient(record)}
              />
            </Tooltip>
            <Tooltip title="Edit Patient">
              <Button
                type="default"
                size="small"
                icon={<EditOutlined />}
                onClick={() => this.editPatient(record)}
              />
            </Tooltip>
            <Tooltip title="View History">
              <Button
                type="default"
                size="small"
                icon={<HistoryOutlined />}
                onClick={() => this.viewPatientHistory(record)}
              />
            </Tooltip>
            <Popconfirm
              title="Are you sure you want to delete this patient?"
              onConfirm={() => this.deletePatient(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Delete Patient">
                <Button
                  type="primary"
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                />
              </Tooltip>
            </Popconfirm>
          </Space>
        )
      }
    ];

    return (
      <div style={{ padding: '24px' }}>
        {/* Hidden Print Component */}
        <div style={{ display: 'none' }}>
          <PatientReportToPrint
            ref={el => (this.printRef = el)}
            patients={patients}
            reportTitle="Patient Management Report"
            dateRange={`Generated on ${moment().format('DD/MM/YYYY')}`}
          />
        </div>

        {/* Header */}
        <div style={{ marginBottom: '24px' }}>
          <Row gutter={16} align="middle">
            <Col span={12}>
              <h1 style={{ margin: 0, color: '#1890ff' }}>
                <UserOutlined style={{ marginRight: '8px' }} />
                Patient Management
              </h1>
              <p style={{ margin: '4px 0', color: '#666' }}>
                Comprehensive patient data management and delivery history
              </p>
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Space>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={this.loadPatients}
                  loading={loading}
                >
                  Refresh
                </Button>
                <ReactToPrint
                  trigger={() => (
                    <Button type="primary" icon={<PrinterOutlined />}>
                      Print Report
                    </Button>
                  )}
                  content={() => this.printRef}
                />
                <ExcelFile
                  filename={`Patient_Report_${moment().format('YYYY-MM-DD')}`}
                  element={
                    <Button type="primary" icon={<DownloadOutlined />}>
                      Export Excel
                    </Button>
                  }
                >
                  <ExcelSheet data={patients} name="Patients">
                    <ExcelColumn label="Patient Name" value="names" />
                    <ExcelColumn label="Age" value="age_in_years" />
                    <ExcelColumn label="Sex" value="sex" />
                    <ExcelColumn label="Phone" value="phone_number" />
                    <ExcelColumn label="Email" value="email_address" />
                    <ExcelColumn label="Nationality" value="nationality" />
                    <ExcelColumn label="Village" value="village_of_residence" />
                    <ExcelColumn label="Sample Number" value="pending_sample_pickup_number" />
                    <ExcelColumn label="Registration Date" value="created_at" />
                  </ExcelSheet>
                </ExcelFile>
              </Space>
            </Col>
          </Row>
        </div>

        {/* Statistics Cards */}
        <Row gutter={16} style={{ marginBottom: '24px' }}>
          <Col span={6}>
            <Card>
              <Statistic
                title="Total Patients"
                value={statistics.totalPatients}
                prefix={<UserOutlined style={{ color: '#1890ff' }} />}
                valueStyle={{ color: '#1890ff' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Male Patients"
                value={statistics.malePatients}
                prefix={<UserOutlined style={{ color: '#52c41a' }} />}
                valueStyle={{ color: '#52c41a' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Female Patients"
                value={statistics.femalePatients}
                prefix={<UserOutlined style={{ color: '#fa8c16' }} />}
                valueStyle={{ color: '#fa8c16' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Recent (30 days)"
                value={statistics.recentRegistrations}
                prefix={<CalendarOutlined style={{ color: '#722ed1' }} />}
                valueStyle={{ color: '#722ed1' }}
              />
            </Card>
          </Col>
        </Row>

        {/* Filters */}
        <Card style={{ marginBottom: '24px' }}>
          <Row gutter={16}>
            <Col span={8}>
              <Input
                placeholder="Search by name, phone, ID number..."
                prefix={<SearchOutlined />}
                value={searchText}
                onChange={(e) => this.handleSearch(e.target.value)}
                allowClear
              />
            </Col>
            <Col span={4}>
              <Select
                placeholder="Filter by Sex"
                value={selectedSex}
                onChange={this.handleSexFilter}
                allowClear
                style={{ width: '100%' }}
              >
                <Option value="Male">Male</Option>
                <Option value="Female">Female</Option>
              </Select>
            </Col>
            <Col span={6}>
              <Select
                placeholder="Filter by Nationality"
                value={selectedNationality}
                onChange={this.handleNationalityFilter}
                allowClear
                showSearch
                style={{ width: '100%' }}
              >
                {nationalities.map(nationality => (
                  <Option key={nationality} value={nationality}>
                    {nationality}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col span={6}>
              <Space>
                <Button onClick={this.clearFilters}>
                  Clear Filters
                </Button>
                <Badge count={patients.length} showZero>
                  <Button type="primary">
                    Showing Results
                  </Button>
                </Badge>
              </Space>
            </Col>
          </Row>
        </Card>

        {/* Patients Table */}
        <Card>
          <Table
            columns={columns}
            dataSource={patients}
            rowKey="id"
            loading={loading}
            pagination={{
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} patients`,
            }}
            scroll={{ x: 1200 }}
            size="middle"
          />
        </Card>

        {/* View Patient Modal */}
        <Modal
          title={
            <div>
              <Avatar icon={<UserOutlined />} style={{ marginRight: '8px' }} />
              Patient Details - {selectedPatient?.names}
            </div>
          }
          visible={viewModalVisible}
          onCancel={() => this.setState({ viewModalVisible: false })}
          footer={[
            <Button key="close" onClick={() => this.setState({ viewModalVisible: false })}>
              Close
            </Button>,
            <Button
              key="edit"
              type="primary"
              icon={<EditOutlined />}
              onClick={() => {
                this.setState({ viewModalVisible: false });
                this.editPatient(selectedPatient);
              }}
            >
              Edit Patient
            </Button>
          ]}
          width={800}
        >
          {selectedPatient && (
            <Descriptions bordered column={2}>
              <Descriptions.Item label="Full Name" span={2}>
                <strong>{selectedPatient.names}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="Age">
                {selectedPatient.age_in_years || selectedPatient.age || 'N/A'} years
              </Descriptions.Item>
              <Descriptions.Item label="Sex">
                <Tag color={selectedPatient.sex === 'Male' ? 'blue' : 'pink'}>
                  {selectedPatient.sex}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="Date of Birth">
                {selectedPatient.date_of_birth ? 
                  moment(selectedPatient.date_of_birth).format('DD/MM/YYYY') : 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="Nationality">
                {selectedPatient.nationality || 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="Phone Number">
                {selectedPatient.phone_number || 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="Email Address">
                {selectedPatient.email_address || 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="OPD/IPD Number">
                {selectedPatient.patient_opd_ipd_number || 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="National ID">
                {selectedPatient.national_id_number || 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="Village of Residence" span={2}>
                {selectedPatient.village_of_residence || 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="Village of Workplace" span={2}>
                {selectedPatient.village_of_workplace || 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="Physical Address" span={2}>
                {selectedPatient.physical_address || 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="Occupation" span={2}>
                {selectedPatient.occupation || 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="Sample Number">
                {selectedPatient.pending_sample_pickup_number || 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="Registration Date">
                {moment(selectedPatient.created_at).format('DD/MM/YYYY HH:mm')}
              </Descriptions.Item>
            </Descriptions>
          )}
        </Modal>

        {/* Edit Patient Modal */}
        <Modal
          title={
            <div>
              <EditOutlined style={{ marginRight: '8px' }} />
              Edit Patient - {selectedPatient?.names}
            </div>
          }
          visible={editModalVisible}
          onCancel={() => this.setState({ editModalVisible: false })}
          onOk={this.savePatient}
          width={800}
          okText="Save Changes"
        >
          {selectedPatient && (
            <Form layout="vertical">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Full Name" required>
                    <Input
                      value={editForm.names}
                      onChange={(e) => this.setState({
                        editForm: { ...editForm, names: e.target.value }
                      })}
                      placeholder="Enter full name"
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Age">
                    <Input
                      type="number"
                      value={editForm.age}
                      onChange={(e) => this.setState({
                        editForm: { ...editForm, age: parseInt(e.target.value) }
                      })}
                      placeholder="Age"
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Sex" required>
                    <Select
                      value={editForm.sex}
                      onChange={(value) => this.setState({
                        editForm: { ...editForm, sex: value }
                      })}
                    >
                      <Option value="Male">Male</Option>
                      <Option value="Female">Female</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item label="Date of Birth">
                    <DatePicker
                      value={editForm.date_of_birth ? moment(editForm.date_of_birth) : null}
                      onChange={(date) => this.setState({
                        editForm: { ...editForm, date_of_birth: date ? date.format('YYYY-MM-DD') : null }
                      })}
                      format="DD/MM/YYYY"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Phone Number">
                    <Input
                      value={editForm.phone_number}
                      onChange={(e) => this.setState({
                        editForm: { ...editForm, phone_number: e.target.value }
                      })}
                      placeholder="Phone number"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Nationality">
                    <Select
                      value={editForm.nationality}
                      onChange={(value) => this.setState({
                        editForm: { ...editForm, nationality: value }
                      })}
                      showSearch
                      placeholder="Select nationality"
                    >
                      {nationalities.map(nationality => (
                        <Option key={nationality} value={nationality}>
                          {nationality}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Email Address">
                    <Input
                      value={editForm.email_address}
                      onChange={(e) => this.setState({
                        editForm: { ...editForm, email_address: e.target.value }
                      })}
                      placeholder="Email address"
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="OPD/IPD Number">
                    <Input
                      value={editForm.patient_opd_ipd_number}
                      onChange={(e) => this.setState({
                        editForm: { ...editForm, patient_opd_ipd_number: e.target.value }
                      })}
                      placeholder="OPD/IPD Number"
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="National ID">
                    <Input
                      value={editForm.national_id_number}
                      onChange={(e) => this.setState({
                        editForm: { ...editForm, national_id_number: e.target.value }
                      })}
                      placeholder="National ID"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Village of Residence">
                    <Input
                      value={editForm.village_of_residence}
                      onChange={(e) => this.setState({
                        editForm: { ...editForm, village_of_residence: e.target.value }
                      })}
                      placeholder="Village of residence"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Village of Workplace">
                    <Input
                      value={editForm.village_of_workplace}
                      onChange={(e) => this.setState({
                        editForm: { ...editForm, village_of_workplace: e.target.value }
                      })}
                      placeholder="Village of workplace"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Physical Address">
                    <TextArea
                      value={editForm.physical_address}
                      onChange={(e) => this.setState({
                        editForm: { ...editForm, physical_address: e.target.value }
                      })}
                      placeholder="Physical address"
                      rows={2}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Occupation">
                    <Input
                      value={editForm.occupation}
                      onChange={(e) => this.setState({
                        editForm: { ...editForm, occupation: e.target.value }
                      })}
                      placeholder="Occupation"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
        </Modal>

        {/* Patient History Drawer */}
        <Drawer
          title={
            <div>
              <HistoryOutlined style={{ marginRight: '8px' }} />
              Delivery History - {selectedPatient?.names}
            </div>
          }
          placement="right"
          width={800}
          visible={historyDrawerVisible}
          onClose={() => this.setState({ historyDrawerVisible: false })}
        >
          {selectedPatient && (
            <div>
              {/* Patient Summary */}
              <Card size="small" style={{ marginBottom: '16px' }}>
                <Row gutter={16}>
                  <Col span={8}>
                    <Statistic
                      title="Total Deliveries"
                      value={deliveryHistory.length}
                      prefix={<MedicineBoxOutlined />}
                    />
                  </Col>
                  <Col span={8}>
                    <Statistic
                      title="Completed"
                      value={deliveryHistory.filter(d => d.delivery_status === 'delivered').length}
                      valueStyle={{ color: '#52c41a' }}
                    />
                  </Col>
                  <Col span={8}>
                    <Statistic
                      title="Pending"
                      value={deliveryHistory.filter(d => d.delivery_status === 'pending').length}
                      valueStyle={{ color: '#fa8c16' }}
                    />
                  </Col>
                </Row>
              </Card>

              {/* Delivery Timeline */}
              <Card title="Delivery Timeline" size="small">
                {deliveryHistory.length > 0 ? (
                  <Timeline>
                    {deliveryHistory.map((delivery, index) => (
                      <Timeline.Item
                        key={delivery.id}
                        color={delivery.delivery_status === 'delivered' ? 'green' : 'orange'}
                      >
                        <div>
                          <div style={{ fontWeight: '500' }}>
                            {delivery.item_name} - {delivery.barcode}
                          </div>
                          <div style={{ fontSize: '12px', color: '#666' }}>
                            Status: <Tag color={delivery.delivery_status === 'delivered' ? 'green' : 'orange'}>
                              {delivery.delivery_status}
                            </Tag>
                          </div>
                          <div style={{ fontSize: '12px', color: '#666' }}>
                            Type: {delivery.barcode_type} | Quantity: {delivery.quantity}
                          </div>
                          {delivery.parent_code && (
                            <div style={{ fontSize: '12px', color: '#666' }}>
                              Parent: {delivery.parent_code}
                            </div>
                          )}
                        </div>
                      </Timeline.Item>
                    ))}
                  </Timeline>
                ) : (
                  <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                    <MedicineBoxOutlined style={{ fontSize: '48px', marginBottom: '16px' }} />
                    <div>No delivery history found for this patient</div>
                  </div>
                )}
              </Card>
            </div>
          )}
        </Drawer>
      </div>
    );
  }
}

export default PatientManagementView;
